import type { HomeConfig } from '@/components/subject/configs.ts';

const homeConfig: HomeConfig = {
  experiments: [

  ],
  mindMaps: [
    {
      title: '先验分布与后验分布',
      description: '先验分布与后验分布是贝叶斯统计中的重要概念，描述了先验知识和观测数据的组合结果。理解这些概念有助于更好地应用贝叶斯统计进行分析和求解。',
      img: '/homePage/s.png',
      path: '/mindmap/question/202',
    },
  ],
  thinking: [
  ],
};

export { homeConfig };
